import { FC } from 'react';
import { Box, HStack, Icon, Link, Text, VStack } from '@chakra-ui/react';
import { Card } from '../../../components';
import { ShiningStar } from '../../../assets';
import { isHeroesType } from '../../../utils';
import { useEventId } from '../../../hooks';

export const Announcements: FC = () => {
  const { pathname, origin } = window.location;
  const eventId = useEventId();
  const oldFCPageBuilder = isHeroesType(String(eventId))
    ? 'heroes_fundraising_center'
    : 'events_fundraising_center';
  const revertUrl = `${origin}${pathname}?fr_id=${String(
    eventId
  )}&pagename=${oldFCPageBuilder}&sc_icid=p2p_fc_classic_revert`;

  return (
    <Card aria-label="Announcements">
      <VStack spacing={3}>
        <HStack w="full">
          <Box pr={3} pt={1} alignSelf="flex-start">
            <Icon boxSize="48px" as={ShiningStar} />
          </Box>
          <Box flex="1" alignSelf="flex-start">
            <Text fontSize={18} align="left">
              Welcome to the new St.&nbsp;Jude Fundraising Center.
            </Text>
          </Box>
        </HStack>

        <Text fontSize={16} align="center">
          <Link
            isExternal
            href="https://www.stjude.org/get-involved/fundraising-ideas/fundraising-center-updates.html"
            textDecoration="none"
          >
            See what's new &gt;
          </Link>
        </Text>

        <Text fontSize={16} align="center">
          <Link href={revertUrl} textDecoration="none">
            Revert to Classic Version &gt;
          </Link>
        </Text>
      </VStack>
    </Card>
  );
};
